"use strict";
(function () {

    var _ = require('lodash'),
        gsap = require('gsap');

    var gs = window.GreenSockGlobals || {};

    var UIControls = function (map) {
        _.bindAll(this);
        this.el = document.getElementById('ui-controls');
        this.map = map;

        var zoomIn = this.el.querySelector('.zoom-in'),
            zoomOut = this.el.querySelector('.zoom-out'),
            refresh = this.el.querySelector('.refresh');


        this.animation = new gs.TimelineMax({
            delay: 1
        });

        this.animation
            .to(refresh, 0.8, {
                y: 0,
                ease: Cubic.easeOut
            })
            .to(zoomIn, 0.8, {
                y: 0,
                ease: Cubic.easeOut
            }, '-=0.8')
            .to(zoomOut, 0.8, {
                y: 0,
                ease: Cubic.easeOut
            }, '-=0.7');
        this.animation.stop();

    };
    UIControls.prototype = {

        _onZoomIn: function (e) {
            e.preventDefault();
            this.map.zoomIn();

        },
        _onZoomOut: function (e) {
            e.preventDefault();
            this.map.zoomOut();
        },

        enable: function () {
            this.el.querySelector('.zoom-in').addEventListener('click', this._onZoomIn);
            this.el.querySelector('.zoom-out').addEventListener('click', this._onZoomOut);
        },
        disable: function () {
            this.el.querySelector('.zoom-in').removeEventListener('click', this._onZoomIn);
            this.el.querySelector('.zoom-out').removeEventListener('click', this._onZoomOut);
        },

        showZoom: function () {
            var zoomIn = this.el.querySelector('.zoom-in'),
                zoomOut = this.el.querySelector('.zoom-out');
            gs.TweenMax.to(zoomIn, 0.8, {
                y: 0,
                ease: Cubic.easeOut
            });
            gs.TweenMax.to(zoomOut, 0.8, {
                y: 0,
                ease: Cubic.easeOut,
                delay: 0.1
            });
        },

        hideZoom: function () {
            var zoomIn = this.el.querySelector('.zoom-in'),
                zoomOut = this.el.querySelector('.zoom-out');
            gs.TweenMax.to(zoomIn, 0.8, {
                y: 200,
                ease: Cubic.easeOut
            });
            gs.TweenMax.to(zoomOut, 0.8, {
                y: 200,
                ease: Cubic.easeOut,
                delay: 0.1
            });
        },

        show: function () {
            this.animation.play();
        },
        hide: function () {
            this.animation.reverse();
        }
    };
    module.exports = UIControls;
}());


/** WEBPACK FOOTER **
 ** ./holiday-map/ui-controls.js
 **/